import { render } from "./OrthoNewPatient.vue?vue&type=template&id=f4abfba8&scoped=true"
import script from "./OrthoNewPatient.vue?vue&type=script&lang=js"
export * from "./OrthoNewPatient.vue?vue&type=script&lang=js"

import "./OrthoNewPatient.vue?vue&type=style&index=0&id=f4abfba8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4abfba8"]])

export default __exports__